import { memo, useMemo, useCallback, useEffect, useState, createRef } from 'react';
import { View, StyleSheet, Text, Image } from 'react-native';
import { Navigation, DateUtils, ActionButton, Panel, AddButton } from '../../components';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getCurrentEmployer } from '../../../selectors/entities';
import {
  updateOccHealthDepartment,
  addOccHealthDepartments,
  deleteOccHealthDepartment,
  resetStatus,
} from '../../employer/actions';
import { BASE_SETUP_OCC_HEALTH } from '../../../constants/permissions';
import * as ASSETS from '../../../constants/assets';
import { currentEmployerPermissions } from '../../../helpers/permissions';
import { getDepartmentsWithReqNames } from '../../employer/selector';

function Row(props) {
  function handleEditDeparmentPress() {
    const r = props.r;

    props.resetStatus();
    Navigation.showModal({
      screen: 'OccHealthDepartmentRequirementsDetails',
      title: r.name,
      passProps: {
        occHealthDepartment: r,
        onSave: handleEditOnSave,
      },
    });
  }

  function handleEditOnSave(department) {
    props.onPress(department);
  }

  function handleDeletePress() {
    const confirmationOpts = {
      title: 'Delete this item?',
      confirm: 'Yes, Delete',
      onConfirmed: () => {
        deleteData(r);
      },
    };
    props.onConfirmationOpts(confirmationOpts);
  }

  function deleteData(department) {
    props.deleteOccHealthDepartment(props.employer.employerId, department);
  }

  function renderButtons() {
    const r = props.r;
    return (
      <View style={[THEME.basicRow, { justifyContent: 'center', flex: 1 }]}>
        <ActionButton
          source={ASSETS.edit}
          disabled={!props.canEdit}
          onPress={handleEditDeparmentPress}
          extraStyle={{ width: 17, height: 17 }}
        />
        <ActionButton
          source={ASSETS.reject}
          disabled={!props.canEdit}
          onPress={handleDeletePress}
        />
      </View>
    );
  }

  const r = props.r;
  const i = props.i;

  if (!__WEB__) {
    return (
      <View
        style={[
          THEME.basicRow,
          { backgroundColor: i % 2 === 0 ? COLOR.contrast : COLOR.altContrast },
        ]}
      >
        <View style={[THEME.rowColumn, { flex: 1 }]}>
          <Text style={THEME.rowText}>{r.department}</Text>
          <Text style={[THEME.rowText, THEME.linkStyle]}>{r.requirements}</Text>
        </View>
        <View style={[THEME.rowColumn, { width: 100 }]}>{renderButtons()}</View>
      </View>
    );
  } else {
    return (
      <View
        style={[
          THEME.basicRow,
          { backgroundColor: i % 2 === 0 ? COLOR.contrast : COLOR.altContrast },
        ]}
      >
        <View style={[THEME.rowColumn, { flexGrow: 1, width: 200 }]}>
          <Text style={THEME.rowText}>{r.name}</Text>
        </View>
        <View style={[THEME.rowColumn, { flexGrow: 1, width: 150 }]}>
          <Text style={[THEME.rowText, THEME.linkStyle]}>{r.requirementNames}</Text>
        </View>
        <View style={[THEME.rowColumn, { width: 150 }]}>
          <Text style={THEME.rowText}>{DateUtils.formatDateStringNumeric(r.updated)}</Text>
        </View>
        <View style={[{ width: 100 }]}>{renderButtons()}</View>
      </View>
    );
  }
}

export default memo(
  connect(
    function (state, ownProps) {
      return {
        employer: getCurrentEmployer(state),
        departmentsWithReqNames: getDepartmentsWithReqNames(state),
        canEdit: currentEmployerPermissions(BASE_SETUP_OCC_HEALTH).canEdit,
      };
    },
    function (dispatch) {
      return {
        actions: bindActionCreators(
          {
            updateOccHealthDepartment,
            addOccHealthDepartments,
            deleteOccHealthDepartment,
            resetStatus,
          },
          dispatch
        ),
      };
    }
  )(function (props) {
    function renderDepartmentRow(r, i) {
      return (
        <Row
          r={r}
          key={`${r.master_department_id}`}
          i={i}
          onPress={handleEditRequirements}
          onConfirmationOpts={props.onConfirmationOpts}
          employer={props.employer}
          deleteOccHealthDepartment={props.actions.deleteOccHealthDepartment}
          canEdit={props.canEdit}
          resetStatus={props.actions.resetStatus}
        />
      );
    }

    function handleEditRequirements(department) {
      props.actions.updateOccHealthDepartment(props.employer.employerId, department);
    }

    function renderAddButton() {
      if (!props.canEdit) return null;
      return (
        <AddButton
          label="ADD"
          onPress={handleAddPress}
          containerStyle={{ height: 40, paddingRight: 10 }}
        />
      );
    }

    function handleSave(departments) {
      props.actions.addOccHealthDepartments(props.employer.employerId, departments);
    }

    function handleAddPress() {
      Navigation.showModal({
        screen: 'OccHealthAddDepartments',
        title: `Add Shops`,
        passProps: {
          onSave: handleSave,
          title: `Add Shops`,
        },
      });
    }

    if (!__WEB__) {
      return <View>{props.departmentsWithReqNames?.map(renderDepartmentRow)}</View>;
    } else {
      return (
        <Panel
          title={'Shop Requirements Checklist'}
          collapsable={false}
          containerStyle={{ minWidth: 820 }}
          extraHeaderContent={renderAddButton()}
        >
          <View>
            <View style={THEME.sectionHeader}>
              <View style={[THEME.sectionHeaderColumn, { flexGrow: 1, width: 200 }]}>
                <Text style={THEME.sectionHeaderText}>DEPARTMENT</Text>
              </View>
              <View style={[THEME.sectionHeaderColumn, { flexGrow: 1, width: 150 }]}>
                <Text style={THEME.sectionHeaderText}>REQUIREMENTS</Text>
              </View>
              <View style={[THEME.sectionHeaderColumn, { width: 150 }]}>
                <Text style={THEME.sectionHeaderText}>DATE UPDATED</Text>
              </View>
              <View style={[THEME.sectionHeaderColumn, { width: 100, borderRightWidth: 0 }]}>
                <Text style={THEME.sectionHeaderText}>ACTIONS</Text>
              </View>
            </View>
            <View>{Object.values(props.departmentsWithReqNames)?.map(renderDepartmentRow)}</View>
          </View>
        </Panel>
      );
    }
  })
);

const styles = StyleSheet.create({});
